const mutations = {
    SET_BACKPAGE: (state, payload) =>  state.backPage = payload,
    RESET_BACKPAGE: (state) =>  state.backPage = undefined,

    INCREMENT_NUMBER: (state) => state.callNumber++,
    DECREMENT_NUMBER: (state) => state.callNumber > 0 ? state.callNumber-- : 0,
}

export default mutations;
